import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { getDisabledModuleFacilityRedirectPath } from "./disabledModuleFacilityRedirect";

/**
 * After a facility page has loaded, send users to the module grid when the
 * facility is not effectively enabled. No staff bypass for facility-level
 * DISABLED.
 */
export function ModuleFacilityRouteGate({
  isReady,
  isEnabled,
  gridPath,
  children,
}: PropsWithChildren<{
  isReady: boolean;
  isEnabled: boolean;
  gridPath: string | undefined;
}>) {
  const redirectTo = getDisabledModuleFacilityRedirectPath({ isReady, isEnabled, gridPath });
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
